import React, {PureComponent} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'
import SVGSymbol from "../SVGSymbol"
import trendingIcon from "../../img/icons/trending.svg"
import {format} from "../../utils/date"
import {getTrending} from "../../selectors/trending";
import {connect} from "react-redux"
import {isTrending} from '../../utils/article'

class ArticleTime extends PureComponent {

    render() {
        const {classes, className, article, trending, hideArticleLength, startWithDivider, variation='normal', dividerSpacing='small', showYear=true} = this.props;
        const is_trending = isTrending( article, trending );

        return <div className={cn(classes.container, className)}>
            {startWithDivider && <span key='divider' className={cn(classes.divider, dividerSpacing)}>|</span>}
            <span className={cn(classes.date, variation)}>{format(article.published_date, showYear)}</span>
            {!hideArticleLength && article.article_length ? [<span key='divider' className={cn(classes.divider, dividerSpacing)}>|</span>, <span key='time' className={cn(classes.time, variation)}>{article.article_length}</span>]: ""}
            {false && !hideArticleLength && is_trending && <SVGSymbol icon={trendingIcon} className={cn(classes.trendingIcon, variation)} />}
        </div>
    }
}

function mapStateToProps(state) {
    return {
        trending: getTrending(state),
    }
}

export default injectSheet((theme) => (
    {
        container: {
            whiteSpace: 'nowrap',
            display: "flex",
            alignItems: "center",
            color: theme.colors.assent,
            fontSize: theme.font.info.fontSize,
            fontWeight: theme.font.info.fontWeight,
            lineHeight: theme.font.info.lineHeight,
        },
        trendingIcon: {
            width: 16,
            height: 16,
            marginLeft: theme.ds.spacing(1),
            '&.small': {
                marginLeft: theme.ds.spacing(1) / 2,
            }
        },
        divider: {
            color: theme.colors.assent,
            margin: [0, theme.ds.spacing(1)],
            [theme.breakpoint('tablet')]: {
              margin: [0, theme.ds.spacing(2)]
            },
            '&.medium, &.small': {
                margin: [0, theme.ds.spacing(1)]
            }
        },
        date: {
            fontSize: 11,
            [theme.breakpoint('tablet')]: {
                fontSize: 12
            }
        },
        time: {
            fontSize: 11,
            [theme.breakpoint('tablet')]: {
                fontSize: 12
            }
        }
    }
))(connect(mapStateToProps)(ArticleTime))





// WEBPACK FOOTER //
// ./src/components/Article/ArticleTime.js